/**
 * Rental Application API Service
 *
 * NOTE: the create/list/decision endpoints below don't exist on the
 * backend yet - GET /dashboard/applications (tenant's own applications)
 * is the only piece that's real today. These are written against the
 * conventions the rest of this API already uses (property-scoped POST
 * for tenant actions, /landlord/{resource}/{action}?id= for landlord
 * actions) so they're ready to call as soon as backend adds them.
 */

import { request, unwrapPatternA } from './apiClient';

const applicationService = {
    /**
     * Submit a rental application for a property
     * @param {number} propertyId
     * @param {Object} payload
     * @param {string} payload.desiredMoveInDate - yyyy-MM-dd
     * @param {number} payload.desiredLeaseLength - months
     * @param {number} payload.desiredRentAmount
     * @param {string} [payload.message]
     * @returns {Promise<{applicationId: number, status: string, message: string}>}
     */
    applyToProperty: async (propertyId, payload) => {
        const data = await request(`/properties/${propertyId}/apply`, {
            method: 'POST',
            body: payload
        });
        return unwrapPatternA(data);
    },

    /**
     * Get applications submitted against the logged-in landlord's properties
     * @param {string} [status]
     * @returns {Promise<{total: number, applications: Array}>}
     */
    getLandlordApplications: async (status = null) => {
        const path = status
            ? `/landlord/applications/list?status=${status}`
            : '/landlord/applications/list';
        const data = await request(path);
        return unwrapPatternA(data);
    },

    /**
     * Approve or reject an application
     * @param {number} applicationId
     * @param {Object} decision
     * @param {'approved'|'rejected'} decision.status
     * @param {string} [decision.reason]
     * @returns {Promise<Object>}
     */
    decideApplication: async (applicationId, decision) => {
        const data = await request(`/landlord/applications/decision?applicationId=${applicationId}`, {
            method: 'POST',
            body: decision
        });
        return unwrapPatternA(data);
    }
};

export default applicationService;
